import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

export const StatusCircle = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(0.5)};
`;

export type StatusCircleToneProps =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'disabled'
  | 'ghost'
  | 'contrast';

interface StatusCircleProps {
  $tone?: StatusCircleToneProps;
}

export const StatusCircleItem = styled.div<StatusCircleProps>`
  --_status-circle-size: ${size(2.5)};

  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--_status-circle-size);
  height: var(--_status-circle-size);
  background-color: var(--_status-circle-bg, var(--c-accent-bg));
  color: var(--_status-circle-fg, var(--c-accent-fg));
  border-radius: 50%;
  font-size: ${(props) => props.theme.font.size.xsmall};
  font-weight: var(--font-weight-bold);
  cursor: default;

  ${({ $tone }) =>
    $tone === 'success'
      ? css`
          --_status-circle-bg: var(--c-semantic-success-300);
          --_status-circle-fg: var(--c-semantic-success-700);
        `
      : $tone === 'error'
        ? css`
            --_status-circle-bg: var(--c-semantic-error-300);
            --_status-circle-fg: var(--c-semantic-error-700);
          `
        : $tone === 'warning'
          ? css`
              --_status-circle-bg: var(--c-semantic-warning-300);
              --_status-circle-fg: var(--c-semantic-warning-700);
            `
          : $tone === 'info'
            ? css`
                --_status-circle-bg: var(--c-semantic-info-300);
                --_status-circle-fg: var(--c-semantic-info-700);
              `
            : $tone === 'disabled'
              ? css`
                  --_status-circle-bg: var(--c-semantic-neutral-300);
                  --_status-circle-fg: var(--c-semantic-neutral-700);
                `
              : $tone === 'ghost'
                ? css`
                    --_status-circle-bg: transparent;
                    --_status-circle-fg: var(--c-semantic-neutral-500);

                    border: 1px solid var(--c-border-main);
                    font-weight: var(--font-weight-regular);
                  `
                : $tone === 'contrast'
                  ? css`
                      --_status-circle-bg: var(--c-contrast-bg);
                      --_status-circle-fg: var(--c-contrast-fg);
                    `
                  : undefined}
`;
